import { Action, combineReducers } from 'redux';

import { ishomeFetchRecommendationsSucceededAction } from '../../home/actions/HomeActions';
import { ContentKeyPrefix, normalizedContentKey } from '../../home/reducers/NormalizedContentReducer';
import { isFetchRecommendationsSucceededAction } from '../../recommendations/actions/FetchRecommendationsActions';
import { isRecommendationHiddenAction, isRecommendationUnhiddenAction } from '../../recommendations/actions/HideRecommendationAction';
import { ListResult } from '../../ts/fetchers/ListResult';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { initialRecommendationsChannelState,RecommendationsChannelState, RecommendationsState } from '../state/RecommendationsState';
import { recommendationsShowMoreReducer } from './RecommendationsShowMoreReducer';

function deriveRecommendationStateFromResult(result: ListResult<IContentInfo>, prefix?: ContentKeyPrefix): RecommendationsChannelState {
  const derivedRecommendationsState: RecommendationsChannelState = {
    items: result.items.map((item: IContentInfo) => normalizedContentKey(item.id, item.contentType, prefix)),
    isFetching: false,
  };

  return derivedRecommendationsState;
}

function derivedRecommendationStateFromAction(previousState: RecommendationsChannelState,
                                                      contentId: string,
                                                      contentType: ExplorableItemType,
                                                      hidden: boolean): RecommendationsChannelState {
  const key: string = normalizedContentKey(contentId, contentType);
  if (previousState.recommendedViewMap && previousState.recommendedViewMap.has(key)) {
    const recommendedViewMap = previousState.recommendedViewMap.set(key, hidden);
    return {
      ...previousState,
      items: Array.from(recommendedViewMap.keys()).filter(k => recommendedViewMap.get(k) === false),
      recommendedViewMap
    };
  }

  return previousState;
}

export function recommendationsChannelReducer(previousState: RecommendationsChannelState = {...initialRecommendationsChannelState}, action: Action) {
  if (isFetchRecommendationsSucceededAction(action) || ishomeFetchRecommendationsSucceededAction(action)) {
    const derivedRecommendationState = deriveRecommendationStateFromResult(action.result);
    return {
      ...derivedRecommendationState,
      recommendedViewMap: new Map(action.result.items.map((item: IContentInfo) => [normalizedContentKey(item.id, item.contentType), false]) as Array<[string, boolean]>),
    };
  }

  if(isRecommendationHiddenAction(action)) {
    return derivedRecommendationStateFromAction(previousState, action.contentId, action.contentType, true);
  }
  if(isRecommendationUnhiddenAction(action)) {
    return derivedRecommendationStateFromAction(previousState, action.contentId, action.contentType, false);
  }
  return previousState;
}

export const recommendationsReducer: (previousState: RecommendationsState, action: Action) => RecommendationsState = combineReducers<RecommendationsState>({
  recommendationsChannelState: recommendationsChannelReducer,
  recommendationsShowMoreState: recommendationsShowMoreReducer
});
